import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { computed, ref } from "@vue/composition-api";
import { useVuelidate } from "@vuelidate/core";
import { minValueNotRequired } from "@Shared/@Utils/new-validation-rules";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { between, required } from "@vuelidate/validators";
import { validPhoneNumberWithExt } from "@Shared/@Utils/validation-rules";
import { AddressRules } from "./goalsPageValidator";
import { incomeHistoryPageBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/income-history/incomeHistoryPageBindingsAndVisibilities";
import { getValidationRulesFromMap } from "@Client/@Composables/application-standalone/validations/getValidationRulesFromMap";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { useApplicantHelpers } from "../pages/applicants/useApplicantHelpers";
import { camelCase, mapKeys } from "lodash";
export const incomeHistoryValidator = (applicantIndex, incomeIndex, {
  lazy = false
} = {}) => {
  const {
    bindings
  } = incomeHistoryPageBindingsAndVisibilities(applicantIndex, incomeIndex, ref("0"));
  const {
    employerName,
    currentJob,
    companyType,
    employmentType,
    grossRevenue,
    incomeAmount,
    incomePeriod,
    incomeType,
    industrySector,
    jobTitle,
    monthsInIndustry,
    occupation,
    operatingAs,
    selfEmployed,
    timeAtJob,
    employmentWorkPhone,
    employmentAddress
  } = bindings;
  const applicantPrefix = computed(() => {
    return applicantIndex.value ? "applicant" : "";
  });
  const {
    GET_SCHEMA_RULES_BY_PATH,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST]);
  const {
    isApplicantVisibleFromFillOut,
    getApplicantIdByIndex
  } = useApplicantHelpers();
  const areRulesVisibleFromFillOut = () => !HAS_CONSOLIDATED_REQUEST.value || isApplicantVisibleFromFillOut(getApplicantIdByIndex(applicantIndex.value));
  const rules = computed(() => {
    return getValidationRulesFromMap(areRulesVisibleFromFillOut, GET_SCHEMA_RULES_BY_PATH, incomeHistoryPageRules, applicantPrefix.value, {
      "co-applicants": applicantIndex.value,
      employment: incomeIndex.value
    });
  });
  const v$ = useVuelidate(rules, {
    employerName,
    currentJob,
    companyType,
    employmentType,
    grossRevenue,
    incomeAmount,
    incomePeriod,
    incomeType,
    industrySector,
    jobTitle,
    monthsInIndustry,
    occupation,
    operatingAs,
    selfEmployed,
    timeAtJob,
    employmentWorkPhone,
    employmentAddress
  }, {
    $scope: true,
    $lazy: lazy
  });
  return {
    v$
  };
};
const incomeHistoryPageRules = {
  employerName: {},
  currentJob: {},
  companyType: {},
  employmentType: {},
  grossRevenue: {
    required: ({
      isRequired,
      getSiblingVisibility
    }) => {
      return isRequired && getSiblingVisibility("self-employed") ? required : {};
    },
    between: between(0, 1000000000000)
  },
  incomeAmount: {
    minValue: ({
      isRequired
    }) => minValueNotRequired(0, isRequired),
    between: () => between(0, 1000000000000)
  },
  incomePeriod: {},
  incomeType: {},
  industrySector: {},
  jobTitle: {},
  monthsInIndustry: {},
  occupation: {},
  operatingAs: {},
  selfEmployed: {},
  timeAtJob: {},
  employmentWorkPhone: {
    validPhoneNumberWithExt: () => validPhoneNumberWithExt
  },
  employmentAddress: AddressRules
};
export const incomeHistoriesValidator = ({
  lazy = false
} = {}) => {
  const {
    allEmployments: employments
  } = useApplicantHelpers();
  const {
    GET_SCHEMA_RULES_BY_PATH
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH]);
  const {
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const withEmployment = ["work-phone", "address"];
  const allEmployments = computed(() => {
    var _context;
    return _flatMapInstanceProperty(_context = employments.value).call(_context, item => isApplicantVisibleFromFillOut(item.applicantId) ? mapKeys(item, (_value, key) => _includesInstanceProperty(withEmployment).call(withEmployment, key) ? camelCase("employment-" + key) : camelCase(key)) : []);
  });
  const rules = computed(() => {
    var _context2;
    const mainApplicantRules = index => getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, incomeHistoryPageRules, "", {
      employment: index
    });
    const coApplicantRules = (coapIndex, index) => getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, incomeHistoryPageRules, "applicant", {
      "co-applicants": coapIndex,
      employment: index
    });
    return _reduceInstanceProperty(_context2 = allEmployments.value).call(_context2, (acc, employment, index) => {
      acc[index] = employment.applicantIndex ? coApplicantRules(employment.index, employment.incomeIndex) : mainApplicantRules(employment.incomeIndex);
      return acc;
    }, {});
  });
  const v$ = useVuelidate(rules, allEmployments, {
    $scope: "incomeHistory",
    $lazy: lazy
  });
  return {
    v$
  };
};